export const parseFromHtml = (descriptionData) => {
  let newDiv = document.createElement("div");

  newDiv.innerHTML = descriptionData.replace(/(<br>)|(<br\/>)|(<\/p>)/g, `\n`);
  return newDiv.innerText;
};
